"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgIncomingCall = function SvgIncomingCall(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    fill: "#00C253"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m15.068.407 1.153 1.027c.871.772 1.012 1.864.421 3.277-.884 2.118-4.2 7.225-11.423 11.543-1.595 1.117-3.026.865-3.683 0a89.48 89.48 0 0 0-1.29-1.657c-.467-.719-.27-1.386.592-2.002 1.291-.923.878-.598 1.935-1.32 1.054-.72 1.046-.558 2.446 0 1.4.561 1.413 1.048 2.8-.27.925-.88 2.11-2.08 3.555-3.604.542-.508.542-1.14 0-1.899-.813-1.138-.813-1.575 0-2.82A23.62 23.62 0 0 1 13.248.406c.602-.542 1.208-.542 1.821 0Z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgIncomingCall);
var _default = exports["default"] = Memo;